import React from "react";
import TourList from "./TourList";
import WhyChooseUs from "./WhyChooseUs";
import HowItWorks from "./HowItWorks";
import Hero from "./components/Hero";

const Home = () => {
  return (
    <div className="home-page">
      <Hero />
      <TourList />
      <WhyChooseUs />
      <HowItWorks />
    </div>
  );
};

export default Home;
